<nav class="breadcrumb bg-primary">
  <div class="container">
    <div class="row align-items-center">
      <div class="col pb-4">
      </div>
      <div class="col-auto">
        <span class="breadcrumb-item">
          <a class="text-white pr-2" href="index.html">Domov</a>
        </span>
        <span class="text-white text-muted">
          >
        </span>
        <span class="breadcrumb-item">
          <a class="text-white pr-2" routerLink="/blog">Blog</a>
        </span>
        <span class="text-white text-muted">
          >
        </span>
        <span class="text-white text-muted pl-2">
          Detail
        </span>
      </div>
    </div>
  </div>
</nav>

<section class="section pb-0 bg-white">
  <div class="container" *ngIf="blogDetail">
    <div class="row align-items-start pl-5 pr-5 mb-5">
      <div class="col-lg-6">
        <h1 class="mb-5">
          {{blogDetail.title1}}
        </h1>
        <h2 class="mb-4">
          {{blogDetail.title2}}
        </h2>
        <div class="mb-4">
          <h4 *ngFor="let description1 of description1Points" class="mb-2">
            {{description1}}
          </h4>
        </div>
      </div>
      <div class="col-lg-6" style="align-self: center;">
        <div class="mb-5 mb-lg-0 pb-0">
          <gallery style="background-color: transparent"></gallery>
        </div>
      </div>
    </div>
    <div class="row align-items-start pl-5 pr-5 pb-5 mb-5">
      <div class="col-lg-12">
        <div class="mb-5">
          <p *ngFor="let description2 of description2items">
            <span class="{{description2.size}}">
              <span *ngFor="let field of description2.content">
                <span class="font-weight-bold" *ngIf="field.bold && !field.italics">{{field.text}}</span>
                <span class="text-muted font-italic" *ngIf="field.italics  && !field.bold">{{field.text}}</span>
                <span class="text-muted" *ngIf="!field.bold  && !field.italics && !field.link && !field.hyperlink">{{field.text}}</span>
                <span *ngIf="field.link"><a href="{{field.text}}" target="_blank">{{field.text}} </a></span>
                <span *ngIf="field.hyperlink"><a href="{{field.hyperlink.hyperlinkText}}" target="_blank">{{field.text}} </a></span>
              </span>
            </span>
            <br *ngFor="let i of counter(description2.space)">
          </p>
        </div>
        <div class="mb-5 pt-5">
          <p *ngFor="let description3 of description3items">
            <span class="{{description3.size}}">
              <span *ngFor="let field of description3.content">
                <span class="font-weight-bold" *ngIf="field.bold && !field.italics">{{field.text}}</span>
                <span class="text-muted font-italic" *ngIf="field.italics  && !field.bold">{{field.text}}</span>
                <span class="text-muted" *ngIf="!field.bold  && !field.italics && !field.link && !field.hyperlink">{{field.text}}</span>
                <span *ngIf="field.link"><a href="{{field.text}}" target="_blank">{{field.text}} </a></span>
                <span *ngIf="field.hyperlink"><a href="{{field.hyperlink.hyperlinkText}}" target="_blank">{{field.text}} </a></span>
              </span>
            </span>
            <br *ngFor="let i of counter(description3.space)">
          </p>
        </div>
        <div class="mb-5 pt-1">
          <!-- ShareThis BEGIN -->
          <div class="sharethis-inline-share-buttons"></div>
          <!-- ShareThis END -->
        </div>
        <div class="mt-3">
          <h3 class="text-blue">
            Kontakt:
          </h3>
          <h3 class="text-blue">
            <span>
              <a href = "mailto:dlhopolcekova@gryf.sk">dlhopolcekova&#64;gryf.sk</a>
            </span>
          </h3>
          <h3 class="text-blue">
            <span>
              <a href="tel:0903 900 962">0903 900 962</a>
            </span>
          </h3>
        </div>
        <div class="pt-3">
          <cite>
            {{getFormattedDate(blogDetail.createdTs)}}, vytvoril(a): {{blogDetail.authorName}}
          </cite>
        </div>
      </div>
    </div>
  </div>
</section>
